"use client";

import Breadcrumbs from "@/components/common/BreadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { getAllImage } from "@/app/api/image/imageAPI";
import { DEFAULT_PAGE_SIZE_IMAGE } from "@/constants/appConstant";
import Paging from "@/components/common/paging/Paging";
import { Skeleton } from "primereact/skeleton";
import { Galleria } from "primereact/galleria";
import OptimizedImage from '@/components/common/optimizedImage/OptimizedImage';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import PageHeader from "@/components/common/page-header";

export default function Home() {
    const [activeIndex, setActiveIndex] = useState(0);
    const galleria = useRef(null);
    const paths = [
        { name: 'TRANG CHỦ', url: '/' },
        { name: 'HÌNH ẢNH' },
    ];
    const [images, setImages] = useState([]);
    const [imageCategory, setImageCategory] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchFilter, setSearchFilter] = useState("");
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE_IMAGE);
    const [hasNext, setHasNext] = useState(true);
    const [totalElements, setTotalElements] = useState(0);

    function removeDuplicates(arr) {
        return [...new Set(arr)];
    }

    const fetchImages = async (keyword, pageNum) => {
        try {
            if (keyword === "Xem tất cả") {
                keyword = ""
            }
            const response = await getAllImage(pageNum, pageSize, keyword);
            if (response && response?.status === 200) {
                if (pageNum === 0) {
                    setImages(response?.data.data.content);
                } else {
                    setImages((prev) => [...prev, ...response?.data.data.content]);
                }

                setHasNext(response?.data.data.hasNext);
                setTotalElements(response?.data.data.totalElements);

                if (imageCategory.length === 0) {
                    let arr = response?.data?.data?.content?.map((item) => item?.imageCategory) || [];
                    arr.unshift("Xem tất cả");
                    setImageCategory(removeDuplicates(arr));
                }
            }
        } catch (error) {
            console.error("Error fetching image", error);
        }
    };

    const fetchData = async (keyword, pageNum) => {
        fetchImages(keyword, pageNum);
    };

    useEffect(() => {
        if (page > 0) fetchImages(searchQuery, page);
    }, [page]);

    useEffect(() => {
        fetchImages(searchFilter, 0);
    }, [searchFilter])

    useEffect(() => {
        fetchImages(searchQuery, 0);
    }, [])

    const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        fetchImages(searchQuery, 0);
    };

    const handleClickSearch = (e) => {
        e.preventDefault();
        fetchData(searchQuery, 0);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setImages([]);
        }
    };

    const handleLoadMore = async () => {
        await setPage(page + 1); 
    };

    const itemTemplate = (item) => {
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <OptimizedImage
                    src={item?.link}
                    alt={item?.name}
                    width={800} 
                    height={600}
                    style={{ width: "100%", height: "auto", display: "block", objectFit: 'contain' }}
                    quality={90} 
                />
            </div>
        );
    };

    const thumbnailTemplate = (item) => {
        return (
            <div style={{ width: '100px', height: '75px', position: 'relative' }}>
                <OptimizedImage
                    src={item?.imageUp || item?.link}
                    alt={item?.name}
                    width={100}
                    height={75}
                    style={{ objectFit: 'cover' }}
                />
            </div>
        );
    };

    return (
        <>
            <div className="card-grid-layout">

            <PageHeader title="Hình ảnh" />

                <div className="container-fluid" style={{ marginTop: "10px" }}>
                    <Breadcrumbs paths={paths} />
                    <div className="custom-search" style={{ float: "right" }}>
                        <form onSubmit={handleSubmit}>
                            <input
                                className="custom-input"
                                style={{ border: '2px solid #ccc' }}
                                type="text"
                                placeholder="Tìm kiếm hình ảnh..."
                                value={searchQuery}
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                            />
                            <FontAwesomeIcon icon={faSearch} className="custom-icon" onClick={handleClickSearch} />
                        </form>
                    </div>
                </div>
                <hr className="w-full  border-t-2 border-gray-600" />

                {images?.length === 0 ? (
                    <div className="container-fluid block-content mb-0 mt-7">
                        <div className="row main-grid flex justify-content-center">
                            <div className="col-sm-9">
                                <div className="tab-content row services">
                                    <div className="tab-pane active">
                                        {[1, 2, 3].map((i) => (
                                            <div key={i} className="service-item col-xs-12 col-sm-4 mb-7">
                                                <Skeleton width="360px" height="270px"></Skeleton>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    // --- DANH SÁCH ẢNH ---
                    <div className="container-fluid block-content mb-0 mt-7">
                        <div className="row main-grid flex justify-content-center">
                            <div className="col-sm-9">
                                <div className="row services">
                                    {images && images?.map((image, index) => (
                                        <React.Fragment key={image?.id || index}>
                                            <div className="service-item col-xs-12 col-sm-4 wow zoomIn mb-7"
                                                data-wow-delay="0.3s">
                                                <div className="img-service"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setActiveIndex(index);
                                                        galleria.current.show();
                                                    }}
                                                >
                                                    <OptimizedImage
                                                        className="full-width"
                                                        src={image?.link}
                                                        alt={image?.name}
                                                        width={360}
                                                        height={270}
                                                        priority={index < 6}
                                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                                    />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))}

                                    <Galleria
                                        ref={galleria}
                                        value={images}
                                        style={{ maxWidth: "850px" }}
                                        activeIndex={activeIndex}
                                        onItemChange={(e) => setActiveIndex(e.index)}
                                        circular
                                        fullScreen
                                        showItemNavigators
                                        showThumbnails={false}
                                        item={itemTemplate} 
                                        thumbnail={thumbnailTemplate}
                                        pt={{
                                            mask: {
                                                'aria-label': 'Trình xem hình ảnh toàn màn hình',
                                                'aria-describedby': 'galleria-description',
                                            },
                                        }}
                                    />
                                </div>
                                <div className="paging-container">
                                    <Paging
                                        onLoadMore={handleLoadMore}
                                        hasNext={hasNext}
                                        totalElements={totalElements}
                                        data={images}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}
